import { useState } from "react";

function ReadMoreText({ text }) {
  const [expanded, setExpanded] = useState(false);

  return (
    <div className="read-more-box">
      <p className={expanded ? "full-text" : "short-text"}>
        {text}
      </p>

      <button
        className="read-more-btn"
        onClick={() => setExpanded(!expanded)}
      >
        {expanded ? "Read Less" : "Read More"}
      </button>
    </div>
  );
}

export default ReadMoreText;